<template>
    <v-container fluid fill-height>
        <Headful title="Bedankt!"></Headful>
        <Header
            color="white"
            show-logo
            :dark="true"
            show-back-button
            extended
        ></Header>
        <v-layout align-center class="mt-0 mb-5">
            <v-flex>
                <v-card class="elevation-0 mx-auto" width="800">
                    <v-card-title></v-card-title>
                    <v-card-text class="pa-7 ">
                        <h1 class="text-h5 mb-5 text-center text--success">Gelukt!</h1>
                        <p>
                            Het profiel is succesvol opgestuurd, er wordt zo spoedig mogelijk contact met je opgenomen.<br><br>
                            Heb je vragen of wil je iets in je profiel aanvullen of wijzingen, mail dan naar <a href="mailto:info@passie-voor-onderwijs.nl">info@passie-voor-onderwijs.nl</a>.<br>
                            Ook om je af te melden voor POrtaal, mail je naar <a href="mailto:info@passie-voor-onderwijs.nl">info@passie-voor-onderwijs.nl</a>.
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";

export default {
    name: "RegisterSuccess",
    components: {
        Headful,
        Header,
    },
    data: () => ({
    }),
    methods: {

    },
}
</script>

<style scoped>

</style>
